import React from 'react';
import { ShipmentsList, ShipmentsTable } from 'src/components/Shipments';
import logisticsImg from 'src/images/logistics.svg';
import { Link } from 'straightline-ui';
import {
  Button,
  Card,
  CardBody,
  Col,
  Icon,
  ListGroup,
  ListGroupItem,
  Row,
  ScreenSize,
  Table,
  TableBody,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  useApp
} from 'straightline-ui';

export default function ShipmentsCard() {
  const app = useApp();
  const {
    result: shipments,
    isLoading,
    isError,
    error
  } = app.service('api/shipments').useFind(
    {
      query: {
        $limit: 5,
        $sort: { pickup_date: -1 },
        $select: [
          'id',
          'reference_number',
          'pickup_address',
          'delivery_address',
          'carrier_id',
          'shipper_id',
          'pickup_date',
          'due_date',
          'status_type',
          'truck_type',
          'travel',
          'load_weight',
          'mode',
          'rate',
          'line_items'
        ]
      }
    },
    { keepPreviousData: true, refetchInterval: 60000 }
  );

  if (isLoading || isError) {
    return <Loader error={error} />;
  }

  if (shipments.total === 0) {
    return (
      <Card>
        <div className="card-header">
          <div className="d-flex justify-content-between">
            <h3 className="card-header-title">Shipments</h3>
            {/* <Link disabled to="/quote">
              Request Quote
            </Link> */}
          </div>
        </div>
        <CardBody style={{ minHeight: 426 }}>
          <Row className="align-items-center">
            <Col className="text-center mb-4 mb-lg-0">
              <img
                src={logisticsImg}
                alt="Get Started"
                className="img-fluid mb-4 mb-xl-0"
              />
            </Col>
            <Col xl="6">
              <h1>Request Quote</h1>
              <p className="mb-4 text-muted lead">
                Get instant quotes from the Straighline pricing algorithm. After
                accepting a quote, your shipment will begin matching with
                carriers nationwide! You can get new quotes anytime by clicking
                "Request Quote" in the sidebar.
              </p>
              <Button to="/quote" color="primary">
                <Icon type="clipboard" className="mr-2" />
                Request Quote
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }

  return (
    <React.Fragment>
      <ScreenSize xs sm md>
        {() => (
          <Card className="card-fill">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="card-header-title">Shipments</h3>
                <Link to="/shipments">View All</Link>
              </div>
            </div>
            <ShipmentsList data={shipments.data} />
          </Card>
        )}
      </ScreenSize>
      <ScreenSize lg xl>
        {() => (
          <Card className="card-fill">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="card-header-title">Shipments</h3>
                <Link to="/shipments">View All</Link>
              </div>
            </div>
            <ShipmentsTable data={shipments.data} />
          </Card>
        )}
      </ScreenSize>
    </React.Fragment>
  );
}

const Loader = ({ error }) => {
  const loaderLength = [1, 2, 3, 4, 5];
  return (
    <React.Fragment>
      <ScreenSize xs sm>
        {() => (
          <Card>
            {error && (
              <div className="d-flex align-items-center justify-content-center rounded p-3">
                <div className="lead text-danger">{error.message}</div>
              </div>
            )}
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="card-header-title">Shipments</h3>
                <Link to="/shipments">View All</Link>
              </div>
            </div>
            <ListGroup className="list-group-flush mb-0">
              {!error &&
                loaderLength.map((item, index) => {
                  return (
                    <ListGroupItem key={index} className="px-4">
                      <div
                      // className="animated flash infinite slower"
                      >
                        <Row className="justify-content-between mb-3">
                          <Col xs="auto">
                            <div
                              className="bg-light rounded"
                              style={{ height: 33, width: 100 }}
                            />
                          </Col>
                          <Col xs="auto">
                            <div className="text-secondary d-flex align-items-center">
                              <div
                                className="bg-light rounded"
                                style={{ height: 14, width: 40 }}
                              />
                              <Icon type="dot" className="text-muted mx-1" />
                              <div
                                className="bg-light rounded"
                                style={{ height: 14, width: 60 }}
                              />
                            </div>
                            <div className="text-secondary d-flex align-items-center">
                              <div
                                className="bg-light rounded"
                                style={{ height: 14, width: 60 }}
                              />
                              <Icon type="dot" className="text-muted mx-1" />
                              <div
                                className="bg-light rounded"
                                style={{ height: 14, width: 40 }}
                              />
                            </div>
                          </Col>
                        </Row>
                        <ListGroup className="list-group list-group-flush list-group-activity">
                          <ListGroupItem className="py-3">
                            <Row>
                              <Col xs="auto">
                                <div className="avatar avatar-sm">
                                  <div className="avatar-title font-size-lg rounded-circle bg-light text-dark">
                                    <Icon type="clipboard" />
                                  </div>
                                </div>
                              </Col>
                              <Col className="ml-n2">
                                <div
                                  className="bg-light rounded mb-1"
                                  style={{ height: 14, width: 120 }}
                                />
                                <div
                                  className="bg-light rounded mb-1"
                                  style={{ height: 14, width: 100 }}
                                />
                                <div
                                  className="bg-light rounded mb-1"
                                  style={{ height: 14, width: 190 }}
                                />
                                <div
                                  className="bg-light rounded mb-1"
                                  style={{ height: 14, width: 75 }}
                                />
                              </Col>
                            </Row>
                          </ListGroupItem>

                          <ListGroupItem className="py-3">
                            <Row>
                              <Col xs="auto">
                                <div className="avatar avatar-sm">
                                  <div className="avatar-title font-size-lg rounded-circle bg-light text-dark">
                                    <Icon type="truck" />
                                  </div>
                                </div>
                              </Col>
                              <Col className="ml-n2">
                                <div>
                                  <div
                                    className="bg-light rounded mb-2"
                                    style={{ height: 18, width: 160 }}
                                  />
                                  <div>
                                    <div
                                      className="bg-light rounded"
                                      style={{ height: 16, width: 140 }}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </ListGroupItem>
                          <ListGroupItem className="pt-3 pb-0">
                            <Row>
                              <Col xs="auto">
                                <div className="avatar avatar-sm">
                                  <div className="avatar-title font-size-lg rounded-circle bg-light text-dark">
                                    <Icon type="map-pin" />
                                  </div>
                                </div>
                              </Col>
                              <Col className="ml-n2">
                                <div>
                                  <div
                                    className="bg-light rounded mb-2"
                                    style={{ height: 18, width: 170 }}
                                  />
                                  <div
                                    className="bg-light rounded"
                                    style={{ height: 18, width: 170 }}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </ListGroupItem>
                        </ListGroup>
                      </div>
                    </ListGroupItem>
                  );
                })}
            </ListGroup>
          </Card>
        )}
      </ScreenSize>
      <ScreenSize md lg xl>
        {() => (
          <Card className="card-fill">
            <div className="card-header border-bottom-0">
              <div className="d-flex justify-content-between">
                <h3 className="card-header-title">Shipments</h3>
                <Link to="/shipments">View All</Link>
              </div>
            </div>
            {error && (
              <div className="d-flex align-items-center justify-content-center rounded p-3">
                <div className="lead text-danger">{error.message}</div>
              </div>
            )}
            {!error && (
              <div>
                <div className="table-responsive">
                  <Table className="table table-nowrap card-table">
                    <TableHead>
                      <TableRow>
                        <TableHeader className="py-3">Status</TableHeader>
                        <TableHeader className="py-3">ID</TableHeader>
                        <TableHeader className="py-3">Pickup</TableHeader>
                        <TableHeader className="py-3">
                          <p className="ml-4 mb-0">Delivery</p>
                        </TableHeader>
                        <TableHeader className="py-3">Carrier</TableHeader>
                      </TableRow>
                    </TableHead>
                    <TableBody className="list">
                      {loaderLength.map((item) => (
                        <TableRow style={{ height: 79 }} key={item}>
                          <TableData>
                            <div
                              className="bg-light rounded"
                              style={{ height: 29, width: 78 }}
                            />
                          </TableData>
                          <TableData>
                            <div
                              className="bg-light rounded mb-2"
                              style={{ height: 18, width: 20 }}
                            />
                            <div
                              className="bg-light rounded"
                              style={{ height: 18, width: 55 }}
                            />
                          </TableData>
                          <TableData className="pr-0">
                            <div
                              className="bg-light rounded mb-2"
                              style={{ height: 18, width: 92 }}
                            />
                            <div
                              className="bg-light rounded"
                              style={{ height: 18, width: 89 }}
                            />
                          </TableData>
                          <TableData className="pl-0">
                            <div className="d-inline-block mx-2">
                              <Icon
                                type="arrow-right"
                                className="text-light"
                                style={{ fontSize: 25 }}
                              />
                            </div>
                            <div
                              className="d-inline-block"
                              style={{ marginBottom: -7 }}
                            >
                              <div
                                className="bg-light rounded mb-2"
                                style={{ height: 18, width: 92 }}
                              />
                              <div
                                className="bg-light rounded"
                                style={{ height: 18, width: 89 }}
                              />
                            </div>
                          </TableData>
                          <TableData>
                            <div
                              className="bg-light rounded"
                              style={{ height: 18, width: 170 }}
                            />
                          </TableData>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>
            )}
          </Card>
        )}
      </ScreenSize>
    </React.Fragment>
  );
};
